export interface StatusClass{
    AccountStatusId:number,
    Status:string,
    StatusTypeId:number,
    AccountId:number,
    IsDisabled:boolean,
    MasterAccountStatusId:number,
    // AccountStatusGuidId:string,
    IsDeleted:boolean,
    IsClosed:boolean,
    isSelected:number
}


const common = {    
    Status:"",
    StatusTypeId:0,
    IsClosed:false,
    IsDisabled:false,
    MasterAccountStatusId:null
  };
  export const StatusInitialsForAdd = { ...common };
  
  export const StatusInitialsForUpdate = {
    ...common,
    AccountStatusId: 0
  };

// export const StatusInitialsForApp ={
//     Status:"",
//     StatusTypeId:0,
//     IsClosed:false,
//     IsDisabled:false,
//     MasterAccountStatusId:null
// }

// export const StatusInitialsForUpdate ={
//     AccountStatusId:0,
//     Status:"",
//     StatusTypeId:0,
//     IsClosed:false,
//     SystemStatusType:"",
//     IsDisabled:false,
//     MasterAccountStatusId:null
// }